import React, { useContext } from 'react';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import Keycloak from 'keycloak-js';
import { UserContext } from '../context/UserContext';
import { useNavigate } from 'react-router-dom';
import AxiosInstance from '../state/api/AxiosInstance';

const keycloak = new Keycloak({
	url: '/auth',
	realm: 'iwd',
	clientId: 'iwd-backoffice',
});

const Auth = (props) => {
	const { setUser } = useContext(UserContext);
	let navigate = useNavigate();

	const initialOptions = {
		onLoad: 'login-required',
		pkceMethod: 'S256',
		enableLogging: true,
		checkLoginIframe: false,
		checkLoginIframeInterval: 10,
	};

	const onTokens = (tokens) => {
		const userData = {
			id: keycloak.tokenParsed.sub,
			firstName: keycloak.tokenParsed.given_name,
			lastName: keycloak.tokenParsed.family_name,
			email: keycloak.tokenParsed.email,
			company: keycloak.tokenParsed.company,
			roles: keycloak.tokenParsed.realm_access.roles,
			hasLoaded: false,
		};

		AxiosInstance.setAuthToken(tokens.token);
		setUser({
			...userData,
			hasLoaded: true,
		});
	};

	return (
		<ReactKeycloakProvider
			authClient={keycloak}
			initOptions={initialOptions}
			LoadingComponent={<div />}
			isLoadingCheck={() => !keycloak.authenticated}
			onTokens={onTokens}>
			{props.children}
		</ReactKeycloakProvider>
	);
};

export default Auth;
